var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8398C24.8366 32.8398 32 25.6764 32 16.8398C32 8.00329 24.8366 0.839844 16 0.839844C7.16344 0.839844 0 8.00329 0 16.8398C0 25.6764 7.16344 32.8398 16 32.8398Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 23.7963C19.8424 23.7963 22.9569 20.6818 22.9569 16.8398C22.9569 12.9978 19.8424 9.8833 16.0004 9.8833C12.1585 9.8833 9.04395 12.9978 9.04395 16.8398C9.04395 20.6818 12.1585 23.7963 16.0004 23.7963Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.839844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJapan);
export default __webpack_public_path__ + "static/media/flag_japan.186ddc19cf8fbd04360907c1ade1263c.svg";
export { ForwardRef as ReactComponent };